import Vue from 'vue'
import Router from 'vue-router'
import menuModule from '@/store/modules/menu';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
// Polestar
const ReportList = () => import('@/views/polestar/report_list')
const RowaAalyzeById = () => import('@/views/polestar/rowanalyzebyid')
const ReportModuleIframe = () => import('@/views/polestar/reportmoduleiframe')
const NlpPhrasePage = () => import('@/views/polestar/nlp_phrase_page')
const ProjectsDetailed = () => import('@/views/polestar/projects_detailed')
const ProjectStatisticResults = () => import('@/views/polestar/project_statistics_results')
const PoleStarProjectList = () => import('@/views/polestar')
const PolestarProjects = () => import('@/views/polestar/projects')
const PolestarProjectsDetails = () => import('@/views/polestar/projects/details')
const WisdomStats = () => import('@/views/polestar/wisdomstats')
const Article = () => import('@/views/polestar/article')
const SmsProvider = () => import('@/views/sms')
const Technical = () => import('@/views/polestar/technical')
const Contact = () => import('@/views/polestar/contact')
const Terminology = () => import('@/views/polestar/terminology')
const Tutorials = () => import('@/views/polestar/tutorials')

const Log = () => import('@/views/log')
const Help = () => import('@/views/help')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')


// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/Login')
const Logout = () => import('@/views/Logout')
const Register = () => import('@/views/Register')
const ResetPassword = () => import('@/views/ResetPassword')
const AdministratorRegister = () => import('@/views/Register')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
      path: '/',
      redirect: 'dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [{
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            'loginx': 1
          }
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: '/help',
          name: 'help',
          component: Help
        },
        {
          path: '/log',
          name: 'log',
          component: Log
        },
        {
          path: '/projectlist',
          name: 'projectlist',
          component: PoleStarProjectList
        },
        {
          path: '/projects/detailed',
          name: 'projectsdetailed',
          component: ProjectsDetailed
        },
        {
          path: '/report-module',
          name: 'report_list',
          component: ReportList
        },
        {
          path: '/rowanalyzebyid',
          name: 'rowanalyzebyid',
          component: RowaAalyzeById,
          meta: {
            'loginx': 0
          }          
        },
        {
          path: '/reportmoduleiframe',
          name: 'reportmoduleiframe',
          component: ReportModuleIframe,
          meta: {
            'loginx': 0
          }
        },
        {
          path: '/nlp_phrase',
          name: 'nlp_phrase',
          component: NlpPhrasePage,
          meta: {
            'loginx': 0
          }
        },
        {
          path: '/project-statistics-results',
          name: 'projectstatisticresults',
          component: ProjectStatisticResults,
          meta: {
            'loginx': 0
          }
        },
        {
          path: '/polestar/projects',
          name: 'polestarprojects',
          component: PolestarProjects
        },
        {
          path: '/polestar/projects/details',
          name: 'polestarprojectsdetails',
          component: PolestarProjectsDetails
        },
        {
          path: '/polestar/wisdomstats',
          name: 'wisdomstats',
          component: WisdomStats
        },
        {
          path: '/technical',
          name: 'technical',
          component: Technical,
          meta: {
            'loginx': 1
          }
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contact,
          meta: {
            'loginx': 1
          }
        },
        {
          path: '/terminology',
          name: 'terminology',
          component: Terminology,
          meta: {
            'loginx': 1
          }
        },
        {
          path: '/tutorials',
          name: 'tutorials',
          component: Tutorials,
          meta: {
            'loginx': 1
          }
        },
        {
          path: '/polestar/article',
          name: 'article',
          component: Article
        },
        {
          path: '/smsprovider',
          name: 'smsprovider',
          component: SmsProvider
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [{
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: ResetPassword
    }
  ]
})
